import React, { useMemo, useState } from 'react';
import { useAppContext } from '../../Services/AppContext';
import MediaViewerModal from '../MediaViewer/MediaViewerModal';
import AttachmentButton from '../Button/AttachmentButton';
import {
	CaseEntry,
	DocumentationFile,
	useDocumentationFilesQuery,
} from '../../graphql/graphql';
import Loading from '../Loading';
import { prepareDocumentationFileForMediaViewer } from '../../Modules/Ecard/Services/eCardFile.service';
import MultiMediaViewerModal from '../../Modules/Base/Components/MultiMediaViewer/MultiMediaViewerModal';
import { IMultiMediaViewerItem } from '../../Modules/Base/Components/MultiMediaViewer/MultiMediaViewerItem';

interface Props {
	entry: CaseEntry;
}

const CaseChatEntryDocumentation: React.FC<Props> = ({ entry }) => {
	const { socketUrl } = useAppContext();
	const [mediaViewerOpened, setMediaViewerOpened] = useState(false);
	const { data, isLoading } = useDocumentationFilesQuery({
		fileIds: [entry.extra.fileId],
		grouped: false,
	});

	const file: DocumentationFile | undefined = useMemo(() => {
		return data?.documentationFiles?.data?.[0] as DocumentationFile;
	}, [data]);

	const hasGroupFiles = (file?.groupFiles?.length || 0) > 0;

	if (isLoading) {
		return <Loading />;
	}

	return (
		<>
			<div className='mb-2'>{entry.message}</div>
			<>
				{file && (
					<AttachmentButton
						onClick={() => setMediaViewerOpened(true)}
						title={'base.shared.show'}
					/>
				)}
				{mediaViewerOpened && !hasGroupFiles && (
					<MediaViewerModal
						opened
						onClose={() => setMediaViewerOpened(false)}
						file={prepareDocumentationFileForMediaViewer(file, socketUrl)}
					/>
				)}
				{mediaViewerOpened && hasGroupFiles && (
					<MultiMediaViewerModal
						files={file.groupFiles as IMultiMediaViewerItem[]}
						isOpen
						onClose={() => setMediaViewerOpened(false)}
					/>
				)}
			</>
		</>
	);
};

export default CaseChatEntryDocumentation;
